export default {
  evaluation_dashboard: {
    title: 'แผงหน้าปัดผู้ซื้อ',
    unit: ' บริษัท',
    average: 'คะแนนเฉลี่ย:',
    point: ' คะแนน',
    answered_label: 'ส่งแล้ว',
    evaluated_label: 'ประเมินแล้ว',
    corporate_average: 'ค่าเฉลี่ยของซัพพลายเออร์ของคุณ',
    points_earned_by_companies: 'การกระจายคะแนนของซัพพลายเออร์ของคุณ',
    year_modal: {
      title: 'เลือกปี',
      label: 'ปี',
    },
    response_status_title: 'การกระจายสถานะคำตอบ',
    response_status_rating_nothing: 'ยังไม่มีคำตอบ',
    esg_rating_title: 'การกระจายคะแนน ESG',
    esg_score_title: 'การกระจายคะแนน ESG',
    category_scores_title: 'เปรียบเทียบคะแนนตามหมวดหมู่',
    category_scores_distribution_title: 'การกระจายคะแนน ESG ตามหมวดหมู่',
    category_score_data_all_label: 'ค่าเฉลี่ยของ ASUENE ESG',
    esg_scores_by_industry_title: 'การกระจายคะแนน ESG ตามอุตสาหกรรม',
    environment_score_title: 'การกระจายคะแนนสภาพแวดล้อม',
    social_score_title: 'การกระจายคะแนนโซเชียล',
    governance_score_title: 'การกระจายคะแนนธรรมาภิบาล',
    environment_score_subtitle_upper5: 'คะแนนสิ่งแวดล้อมที่ดีที่สุด 5 อันดับแรก',
    environment_score_subtitle_lower5: 'คะแนนสภาพแวดล้อมที่แย่ที่สุด 5 อันดับแรก',
    social_score_subtitle_upper5: 'คะแนนโซเชียลที่ดีที่สุด 5 อันดับแรก',
    social_score_subtitle_lower5: 'คะแนนโซเชียลที่แย่ที่สุด 5 อันดับแรก',
    governance_score_subtitle_upper5: 'คะแนนธรรมาภิบาลที่ดีที่สุด 5 อันดับแรก',
    governance_score_subtitle_lower5: 'คะแนนธรรมาภิบาลที่แย่ที่สุด 5 อันดับแรก',
    // empty_error_message: "",
    common: {
      companies: ' บริษัท',
      update_date: 'วันที่อัปเดตล่าสุด',
    },
    registration_rate: {
      title: 'อัตราการลงทะเบียน',
      tip: 'บริษัทที่จดทะเบียนใน ASUENE ESG จากจำนวนบริษัททั้งหมดที่ต้องได้รับการประเมิน',
    },
    answer_rate: {
      title: 'อัตราการส่ง',
      tip: 'บริษัทที่ส่งแบบสำรวจจากจำนวนบริษัททั้งหมดที่ต้องได้รับการประเมิน',
    },
    days_remaining: {
      title: 'จำนวนวันจนกว่าจะสิ้นสุดการสำรวจ',
      tip: 'จำนวนวันที่เหลือจนกว่าจะถึงวันครบกำหนด\nหากคุณต้องการเปลี่ยนแปลงวันครบกำหนด โปรดติดต่อเรา',
      days_remaining_before: 'เหลือ',
      days_remaining_after: 'วัน',
      expired: 'เกินวันครบกำหนดแล้ว',
    },
    answer_transition: {
      title: 'แนวโน้มการส่ง',
      companies_submitted: 'บริษัทที่ส่งแล้ว',
      breakdown: 'รายละเอียด',
      unregistered: 'ไม้ได้ลงทะเบียน',
      total: 'รวมทั้งหมด',
      number_of_companies: 'จำนวนบริษัท',
    },
    answer_list: {
      title: 'การส่งล่าสุด',
      submitted_at: 'วันที่ส่ง',
    },
  },
}
